import { Grid } from "@mui/material";
import { useEffect, useReducer, useRef } from "react"
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert"
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer"
import ManufacturerControlService from "./ManufacturerControlService"
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import DefaultChip from '../../componentes/chip/DefaultChip';
import { Typography } from "@material-ui/core";

/**
 * Author : AndréK
 * 26/08/2022
*/
const columnsManufacturer = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "manufacturerName",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="manufacturerName" name="cnpj" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.manufacturerName}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "socialReason",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="socialReason" name="cnpj" />;
        },
        flex: 1,
        template: (props) => {
            return (
                <>
                    {props.cnpj ?
                        <DefaultChip
                            style="gray"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.socialReason}
                            </Typography>}
                        />
                        : null}
                </>
            )
        }
    },
    {
        field: "cnpj",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="cnpj" name="cnpj" />;
        },
        flex: 1,
        template: (props) => {
            return (
                <>
                    {props.cnpj ?
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.cnpj}
                            </Typography>}
                        />
                        : null}
                </>
            )
        }
    },
    {
        field: "sac",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="sac" name="cnpj" />;
        },
        flex: 1,
        template: (props) => {
            return (
                <>
                    {props.cnpj ?
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body2"
                                style={{ whiteSpace: 'normal' }}>{props.sac}
                            </Typography>}
                        />
                        : null}
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const ManufacturerRegister = ({ updateId }) => {

    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");
    const cnpjRef = useRef(null);
    const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);

    const initialState = {
        id: 0,
        idClient: loggedIdClient !== 0 ? loggedIdClient : 0,
        clientName: "",
        manufacturerName: "",
        socialReason: "",
        cnpj: "",
        sac: "",
        manufacturerRows: [],
        img: "",
        loggedUserId: userId,
        status: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }


    const [ManufacturerControl, dispatch] = useReducer(reducer, initialState);

    const { id, manufacturerName, clientName, socialReason, cnpj, idClient, sac, status, img } = ManufacturerControl
    const { success, error, manufacturerRows, ...data } = ManufacturerControl

    useEffect(() => {
        updateId({ id: id })
    }, [id])

    const handleChange = (event) => {
        const { name, value } = event.target;

        dispatch({ type: "update", data: { [name]: value } });
    };

    const handleSearch = () => {
        ManufacturerControlService
            .getManufacturer(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { manufacturerRows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { manufacturerRows: [] } }));
    }
    const canSave = () => manufacturerName !== "" && idClient !== 0 && status !== 2;

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                ManufacturerControlService
                    .updateManufacturer(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                ManufacturerControlService
                    .createManufacturer(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id, message: t("noDataExport") } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }

    }

    const handleCellClickManufacturer = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                idClient: data.idClient,
                manufacturerName: data.manufacturerName,
                clientName: data.clientName,
                socialReason: data.socialReason,
                cnpj: data.cnpj,
                status: data.status,
                sac: data.sac,
            }
        })
    }

    const handleReloadImg = () => {
        ManufacturerControlService
            .getManufacturer(data)
            .then((response) => {
                if (response.status === 200) {
                    const rows = []
                    response.data.forEach(item => {
                        rows.push({
                            id: item.id,
                            manufacturerName: item.manufacturerName,
                            clientName: item.clientName,
                            idClient: item.idClient,
                            socialReason: item.socialReason,
                            cnpj: item.cnpj,
                            sac: item.sac,
                            status: item.status
                        });
                    });
                    dispatch({ type: 'update', data: { ...rows[0], ManufacturerRows: rows } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { manufacturerRows: [] } }));
    }

    useEffect(() => {
        handleSearch();
    }, [])

    // CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico
    const handleChangeCNPJ = (event) => {
        let value = event.target.value
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "");

        // REGRA: Dígitos verificadores (13 e 14) só podem ser números
        if (value.length > 12) {
            const dv = value.substring(12, 14);

            if (/[^\d]/.test(dv)) {
                // impede entrada de letras no DV
                return;
            }
        }

        const formatted = formatCNPJ(value);

        dispatch({
            type: "update",
            data: { cnpj: formatted }
        });
    };

    const formatCNPJ = (value) => {
        const cnpj = value
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
            .substring(0, 14);

        if (cnpj.length <= 2) {
            return cnpj;
        }

        if (cnpj.length <= 5) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2)}`;
        }

        if (cnpj.length <= 8) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5)}`;
        }

        if (cnpj.length <= 12) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8)}`;
        }

        return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8, 12)}-${cnpj.substring(12, 14)}`;
    };
    // Fim - CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico

    return (
        <>
            <DefaultScreenAccordion
                title={t("manufacturer")}
                isRegister
                fields={
                    <GridItemContainer>
                        <CustomAlert
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <Grid item xs={id !== 0 ? 7 : 12} sm={id !== 0 ? 8 : 12} md={id !== 0 ? 10 : 12}>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={3}>
                                    <div style={{
                                        pointerEvents: loggedIdClient !== 0 ? "none" : "auto",
                                        opacity: loggedIdClient !== 0 ? 0.8 : 1
                                    }}>

                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name={loggedIdClient !== 0 ? "unLock" : "user"}
                                                    labelName="client"
                                                />
                                            }
                                            name="idClient"
                                            onChange={loggedIdClient !== 0 ? undefined : handleChange}
                                            disabled={loggedIdClient !== 0}
                                            value={idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClient'
                                            error={error && idClient === 0}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="manufacturerName" />
                                        }
                                        name="manufacturerName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={manufacturerName}
                                        inputProps={{ maxLength: 50 }}
                                        error={error && manufacturerName === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="socialReason" />
                                        }
                                        name="socialReason"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={socialReason}
                                        inputProps={{ maxLength: 150 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    {/* CBernardo - 17/06/2026 - Função antiga de CNPJ */}
                                    {/* <InputField
                                        inputRef={cnpjRef}
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="cnpj" />
                                        }
                                        name="cnpj"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={cnpj}
                                        mask="99.999.999/9999-99"
                                        inputProps={{ maxLength: 18 }}
                                    /> */}
                                    {/* Fim - CBernardo - 17/06/2026 - Função antiga de CNPJ */}

                                    {/* CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico */}
                                    <InputField
                                        inputRef={cnpjRef}
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="cnpj" />
                                        }
                                        name="cnpj"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChangeCNPJ}
                                        value={cnpj}
                                        inputProps={{ maxLength: 18 }}
                                        error={error && cnpj === ""}
                                    />
                                    {/* Fim - CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico */}
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="sac" />
                                        }
                                        name="sac"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={sac}
                                        inputProps={{ maxLength: 18 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && status === 2}
                                    />
                                </Grid>
                            </GridInputRow>
                        </Grid>

                        <SearchClearSaveRow
                            onClickSearch={handleSearch}
                            onClickClear={() => dispatch({ type: 'clear' })}
                            onClickSave={handleSaveUpdate}
                        />
                        {(manufacturerRows.length > 0) ? (
                            <GridInputRow>
                                <Grid item xs={12}>
                                    <DefaultDatagrid
                                        columns={columnsManufacturer(t)}
                                        dataSource={manufacturerRows}
                                        allowPaging={true}
                                        cellSelected={(args, grid) =>
                                            handleCellClickManufacturer(args.data)
                                        } />
                                </Grid>
                            </GridInputRow>
                        ) : null}
                    </GridItemContainer>
                } />
        </>
    );
}